import * as Sentry from '@sentry/nuxt'

/**
 * Global error handler plugin that captures all unhandled exceptions
 * (Vue errors, Nuxt lifecycle errors) and sends them to Sentry.
 *
 * Only registers handlers if Sentry is enabled and initialized.
 */
export default defineNuxtPlugin((nuxtApp) => {
  const { sentry: sentryConfig } = useRuntimeConfig().public

  if (!sentryConfig.enabled || !sentryConfig.dsn) {
    return
  }

  // Catch unhandled Vue component errors (rendering, lifecycle hooks, etc.)
  nuxtApp.vueApp.config.errorHandler = (error, instance, info) => {
    Sentry.captureException(error, {
      extra: {
        componentName: instance?.$options?.name || instance?.$options?.__name,
        info,
      },
    })
    // Log to console in development for easier debugging
    if (import.meta.dev) {
      console.error('[Sentry] Vue error captured:', error, info)
    }
  }

  // Catch Nuxt-level errors (SSR errors, middleware errors, plugin errors, etc.)
  nuxtApp.hook('app:error', (error) => {
    Sentry.captureException(error)
    if (import.meta.dev) {
      console.error('[Sentry] App error captured:', error)
    }
  })
})
